import styled from 'styled-components'

export const ReceiptNumberContainer = styled.div`
  margin-left: 20px;
  background-color: #cdcdcd;
  color: #fff;
  height: 85px;
  width: 85px;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h2 {
    padding: 0;
    color: #fff;
    font-size: 35px !important;
    line-height: 40px;
    font-weight: 600;
  }
  p {
    margin: 0;
    color: #fff;
    font-weight: 500;
    font-size: 9px !important;
    line-height: 13px;
  }
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  h2 {
    color: ${({ theme }) => theme.FontColor};
  }
  p {
    color: ${({ theme }) => theme.FontColor};
  }
`

export const AnimationContainer = styled.div`
  border-radius: 5px;
  overflow: hidden;
  grid-column: 1 / -1;
`
